import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';
import { helveticaBold, helveticaRoman } from '../../theme-constants/typograhy-overrides';




export const buttonStyles = makeStyles((theme) => ({
    primaryButton: {
        backgroundColor: tcsmColors.blue,
        color: tcsmColors.white,
        border: 'transparent',
        padding: theme.spacing(.625),
        fontSize: '.825rem',
        fontWeight: 700,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '3px',
        outline: '1px solid transparent',
        outlineOffset: '2px',
        fontFamily: helveticaBold,
       

        '&:hover': {
            backgroundColor: tcsmColors.darkBlue,
            color: tcsmColors.white,
            boxShadow: '0px 4px 8px rgba(48, 48, 48, 0.3)',
        },
        '&:focus': {
            outlineColor: tcsmColors.darkBlue,
        },
        '&.disabled, &[disabled]': {
            '& svg': {                
                fill: '#A1B7D0',
            },
            color: '#A1B7D0',
            boxShadow: 'none',
            pointerEvents: 'none',
        },
        '& svg': {
            width: '.75rem',
            height: '.75rem',
            marginRight: theme.spacing(.5),
            fill: tcsmColors.white,
        },
    },
    secondaryButton: {
        backgroundColor: tcsmColors.greyFive,
        color: tcsmColors.blue,
        border: 'transparent',
        padding: theme.spacing(.625),
        fontSize: '.825rem',
        fontWeight: 700,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',
        textDecoration: 'none',
        display: 'inline-flex',
        borderRadius: '3px',
        outline: '1px solid transparent',
        outlineOffset: '2px',
        fontFamily: helveticaBold,
        alignItems: 'center',
        '&:hover': {
            backgroundColor: tcsmColors.greySix,
            boxShadow: '0px 4px 8px rgba(48, 48, 48, 0.3)',
        },
        '&:focus': {
            outlineColor: tcsmColors.darkBlue,
        },
        '&.disabled, &[disabled]': {
            '& svg': {                
                fill: '#A1B7D0',
            },
            color: '#A1B7D0',
            boxShadow: 'none',
            pointerEvents: 'none',
        },
        '& svg': {
            width: '.75rem',
            height: '.75rem',
            marginRight: theme.spacing(.5),
            fill: tcsmColors.blue,
        },
    },
    tertiaryButton: {
        backgroundColor: tcsmColors.white,
        color: tcsmColors.blue,
        border: 'transparent',
        padding: theme.spacing(.625),
        fontSize: '.825rem',
        fontWeight: 700,
        textDecoration: 'none',
        display: 'inline-block',
        borderRadius: '3px',
        outline: '1px solid transparent',
        outlineOffset: '2px',
        fontFamily: helveticaBold,
        '&:hover': {
            
            boxShadow: '0px 4px 8px rgba(48, 48, 48, 0.3)',
        },
        '&:focus': {
            outlineColor: tcsmColors.darkBlue,
        },
        '&.disabled, &[disabled]': {
            '& svg': {                
                fill: '#A1B7D0',
            },
            color: '#A1B7D0',
            boxShadow: 'none',
            pointerEvents: 'none',
        },
    },
    linkButton: {
        fontFamily: helveticaRoman,
        background: 'transparent',
        padding: '0',
        border: 'none',
        color: tcsmColors.blue,
        textDecoration: 'underline',
        fontSize: '.875rem',
        lineHeight: '1.25rem',
        display: 'inline-flex',
        textAlign: 'left',
        '&.red-link': {
            color: tcsmColors.red,
        },
        '&:hover': {
            textDecoration: 'none',
        },
        '& svg': {
            width: '1.25rem',
            height: '1.25rem',
            fill: tcsmColors.blue,
            flex: '0 0 auto',

            '& + span': {
                marginLeft: theme.spacing(.25),
            },
        },
        '& span': {

            '& + svg': {
                marginLeft: theme.spacing(.25),
            },
        },
        cursor: 'pointer',
    },


    iconButtonRight: {
        '& svg': {
            marginLeft: theme.spacing(.25),
            marginRight: 0,
        },
    },

    buttonCaption: {
        marginTop: theme.spacing(.25),
    },
    linkButtonList: {
        '& > li': {

            '& + li': {
                marginTop: theme.spacing(1),
            },
        },
    },
}));



